export default __webpack_public_path__ + "static/media/header-bg.c4ae4e0e.webp";